import React, {useState, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";

import {AuthActions, selectIsStartLoginloading} from "@redux";
import {Signing} from "@components";
import {i18, trb, getFormattedLanguageFromStorage} from "@utilities";
import {LOGIN_TYPES} from "@config";
import {LoginBubble} from "./Components/LoginBubble";
import {LoginForm} from "./Components/LoginForm";
import {Typography} from "antd";

const DEFAULT_SUBMIT_STATUS = {
    type: null,
    isSubmitting: false
};

export const LoginContainer = () => {
    const dispatch = useDispatch();
    const [submitting, setSubmitting] = React.useState(false);
    const isLoading = useSelector(selectIsStartLoginloading);
    
    const [submitStatus, setSubmitStatus] = useState({
        type: null,
        isSubmitting: false
    });
    
    const submitLogin = useCallback(
        async values => {
            try {
                setSubmitting(true)
                
                setSubmitStatus({
                    isSubmitting: true,
                    type: values.authType
                });
                const language = getFormattedLanguageFromStorage();
                await dispatch(AuthActions.startLogin({...values, language}));
            } catch (e) {
                resetAll();
                setSubmitting(false)
            }
        },
        [dispatch]
    );
    
    const resetAll = useCallback(() => {
        setSubmitting(false)
        setSubmitStatus(DEFAULT_SUBMIT_STATUS);
    }, []);
    
    return (
        <>
            <div className="col-12 col-md-6 order-2 order-md-1">
                <Typography.Title level={2} className="mb-1">{trb(i18.Labels.LoginPage)}</Typography.Title>
                <Typography.Paragraph className="mt-0 mb-5">{trb(i18.Messages.LoginBubble)}</Typography.Paragraph>
                <LoginForm
                    submitting={submitting}
                    onSubmit={submitLogin}
                    isSubmitting={
                        (submitStatus.isSubmitting && submitStatus.type === LOGIN_TYPES.BIO_FACE) || isLoading
                    }
                />
                {submitStatus.isSubmitting && !isLoading &&
                    (submitStatus.type === LOGIN_TYPES.MOBILE || submitStatus.type === LOGIN_TYPES.SMART_ID) && (
                        <Signing submitReset={resetAll}/>
                    )}
            </div>
            <div className="col-12 col-md-6 order-1 order-md-2 text-center">
                <LoginBubble/>
            </div>
        </>
    );
};
